import { render, staticRenderFns } from "./sub-program-list.vue?vue&type=template&id=665d5509&scoped=true&"
import script from "./sub-program-list.vue?vue&type=script&lang=js&"
export * from "./sub-program-list.vue?vue&type=script&lang=js&"
import style0 from "./sub-program-list.vue?vue&type=style&index=0&id=665d5509&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d5509",
  null
  
)

export default component.exports